exports.components = {
  "component---src-pages-markdown-remark-frontmatter-path-tsx": () => import("./../../../src/pages/{MarkdownRemark.frontmatter__path}.tsx" /* webpackChunkName: "component---src-pages-markdown-remark-frontmatter-path-tsx" */)
}

